/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBillFile
 */
export interface APIBillFile {
    /**
     * 
     * @type {string}
     * @memberof APIBillFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillFile
     */
    bill: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillFile
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIBillFile
     */
    readonly storedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIBillFile
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIBillFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIBillFile interface.
 */
export function instanceOfAPIBillFile(value: object): value is APIBillFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('bill' in value) || value['bill'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('storedAt' in value) || value['storedAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIBillFileFromJSON(json: any): APIBillFile {
    return APIBillFileFromJSONTyped(json, false);
}

export function APIBillFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'bill': json['bill'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'name': json['name'],
        'storedAt': (new Date(json['stored_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'size': json['size'],
    };
}

export function APIBillFileToJSON(value?: Omit<APIBillFile, 'self'|'name'|'stored_at'|'last_modified_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bill': value['bill'],
        'key': value['key'],
        'document': value['document'],
    };
}

